import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconCategory } from "@tabler/icons-react";

export const FormatosDeVentaIcon = IconCategory;
export const FormatosDeVentaHelpText = "* Ingrese aquí los formatos de venta para productos";

export class catFormatosDeVenta extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "FormatosDeVenta";
        this.def.columns.c_category_id.defaultValue = "FormatosDeVenta";
        this.Title = "Formatos de Venta";
        this.HelpText = FormatosDeVentaHelpText;
        this.Icon = FormatosDeVentaIcon;
    }
}